import { FC, useMemo } from "react";

import { PortalDeviceTiles } from "@/components/Portal/components/PortalDeviceTiles/PortalDeviceTiles.tsx";
import { PortalSection } from "@/components/Portal/components/PortalSection/PortalSection.tsx";
import { useGetAllBasketsForCustomer, useGetOptions } from "@/services/api.ts";
import { transformProducts } from "@/utils/tariffUtils.ts";

interface CockpitPurchaseIntentSectionProps {
  manageRoute: string;
}

/**
 * Component that displays the purchase intent tiles (baskets to be activated).
 * It uses the PortalDeviceTiles component for the grid and infinite scroll behavior.
 */
export const CockpitPurchaseIntentSection: FC<
  CockpitPurchaseIntentSectionProps
> = ({ manageRoute }) => {
  const { data: baskets, isLoading } = useGetAllBasketsForCustomer();
  const { data: options } = useGetOptions(131001, undefined, {
    query: { enabled: !!baskets && baskets.length > 0 },
  });

  const processedOptions = useMemo(() => transformProducts(options), [options]);

  const sortedBaskets = useMemo(() => {
    return [...(baskets || [])].sort((a, b) => {
      if (!a.createDate || !b.createDate) {
        return 0;
      }

      return (
        new Date(a.createDate).getTime() - new Date(b.createDate).getTime()
      );
    });
  }, [baskets]);

  if (!isLoading && sortedBaskets.length === 0) {
    return null;
  }

  return (
    <PortalSection titleKey="cockpit.sections.toActivate">
      <PortalDeviceTiles
        manageRoute={manageRoute}
        showMetaTiles={false}
        showPromo={false}
        showSims={false}
        showPurchaseIntents={true}
        basketItems={sortedBaskets}
        useInfiniteScroll={true}
        isLoadingIntents={isLoading}
        processedOptions={processedOptions}
      />
    </PortalSection>
  );
};
